import { AxiosResponse } from "axios";
import { del, get, post, put, routes } from "api";
import {
  ICreateStructuredTemplateRequestData,
  IGetStructuredTemplatesRequestParams,
  IStructuredTemplate,
  IStructuredTemplateGenerationResponseData,
} from "models/structuredTemplates.models";

const structuredTemplates = {
  getStructuredTemplates(
    params: IGetStructuredTemplatesRequestParams,
  ): Promise<AxiosResponse> {
    return get(routes.asset.structuredTemplates.all, {
      params,
    });
  },

  getStructuredTemplate(id: string, projectId: string): Promise<AxiosResponse> {
    return get(routes.asset.structuredTemplates.byId(id), {
      params: { projectId },
    });
  },

  createStructuredTemplate(
    projectId: string,
    data: ICreateStructuredTemplateRequestData,
  ): Promise<AxiosResponse> {
    return post(routes.asset.structuredTemplates.all, {
      params: { projectId },
      data,
    });
  },

  generateStructuredTemplate(
    projectArn: string,
    data: FormData,
    signal?: AbortSignal,
  ): Promise<AxiosResponse<IStructuredTemplateGenerationResponseData>> {
    return post(routes.asset.structuredTemplates.generations, {
      params: { projectArn },
      data,
      headers: { "Content-Type": "multipart/form-data" },
      signal,
    });
  },

  updateStructuredTemplate(
    templateId: string,
    projectId: string,
    data: IStructuredTemplate,
  ): Promise<AxiosResponse> {
    return put(routes.asset.structuredTemplates.byId(templateId), {
      params: { projectId },
      data,
    });
  },

  deleteStructuredTemplate(
    templateId: string,
    projectId: string,
  ): Promise<AxiosResponse> {
    return del(routes.asset.structuredTemplates.byId(templateId), {
      params: { projectId },
    });
  },
};

export default structuredTemplates;
